import { DevTools } from "@capitalos/react";
import { createFileRoute, Outlet, redirect } from "@tanstack/react-router";
import { Loader2 } from "lucide-react";
import { Suspense } from "react";
import { satisfiesRole } from "shared";
import { AppSidebar } from "@/components/app-sidebar";
import { SidebarInset, SidebarProvider } from "@/components/ui/sidebar";
import { useProdMode } from "@/hooks/use-prod-mode";
import { env } from "../../../env";

export const Route = createFileRoute("/_authed/_org")({
  beforeLoad: async ({ context: { queryClient, trpc } }) => {
    const session = await queryClient.ensureQueryData(
      trpc.auth.session.queryOptions(),
    );

    const admin = satisfiesRole(session.role, "admin");
    const org = session.org;

    if (admin && !org?.features.includes("onboarding")) {
      throw redirect({
        to: "/onboard",
      });
    }
  },
  component: RouteComponent,
  loader: ({ context: { queryClient, trpc } }) => {
    queryClient.ensureQueryData(trpc.org.users.queryOptions());
    queryClient.ensureQueryData(trpc.org.getBillingAddress.queryOptions());
  },
});

function RouteComponent() {
  const prodMode = useProdMode();

  return (
    <>
      {env.VITE_ENVIRONMENT !== "production" && !prodMode && <DevTools />}

      <SidebarProvider>
        <AppSidebar />
        <Suspense
          fallback={
            <div className="flex h-screen w-full flex-1 grow items-center justify-center">
              <Loader2 className="size-8 animate-spin" />
            </div>
          }
        >
          <SidebarInset className="overflow-hidden">
            <Outlet />
          </SidebarInset>
        </Suspense>
      </SidebarProvider>
    </>
  );
}
